import React, { Fragment, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addExperience } from '../../actions/profile';

const AddExperience = ({ addExperience, history }) => {
  const [formData, setFormData] = useState({
    company: '',
    title: '',
    location: '',
    from: '',
    to: '',
    current: false,
    description: ''
  });

  const [toDateDisabled, toggleDisabled] = useState(false);

  const { company, title, location, from, to, current, description } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <Fragment>
      <h4 className="my-4">Add Work Experience</h4>
      <p className="rb">
        <i className="fas fa-code-branch" /> Add any developer/programming
        positions that you have had in the past
      </p>
      <small>* = required field</small>
      <form
        className="mt-3"
        onSubmit={(e) => {
          e.preventDefault();
          addExperience(formData, history);
        }}
      >
        <div className="form-group row">
          <label
            htmlFor="edit-title"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            Position title
          </label>
          <div className="col-sm-10 col-md-5">
            <input
              type="text"
              className="form-control form-control-sm"
              aria-describedby="jobtitlehelp"
              id="edit-title"
              name="title"
              value={title}
              onChange={(e) => onChange(e)}
              required
            />
            <small id="jobtitlehelp" className="form-text text-muted">
              Job position you have held
            </small>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-company"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            Company
          </label>
          <div className="col-sm-10 col-md-5">
            <input
              type="text"
              className="form-control form-control-sm"
              aria-describedby="companyhelp"
              id="edit-company"
              name="company"
              value={company}
              onChange={(e) => onChange(e)}
              required
            />
            <small id="companyhelp" className="form-text text-muted">
              Place you have worked
            </small>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-location"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            Location
          </label>
          <div className="col-sm-10 col-md-5">
            <input
              type="text"
              className="form-control form-control-sm"
              aria-describedby="locationhelp"
              id="edit-location"
              name="location"
              value={location}
              placeholder="Orlando, FL"
              onChange={(e) => onChange(e)}
            />
            <small id="schoolhelp" className="form-text text-muted">
              City, ST preferred
            </small>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-exp-from"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            From
          </label>
          <div className="col-sm-10 col-md-5">
            <input
              type="date"
              className="form-control form-control-sm"
              id="edit-exp-from"
              name="from"
              value={from}
              onChange={(e) => onChange(e)}
              required
            />
          </div>
        </div>
        <div className="form-check currently my-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="edit-exp-current"
            name="current"
            checked={current}
            value={current}
            onChange={() => {
              setFormData({ ...formData, current: !current });
              toggleDisabled(!toDateDisabled);
            }}
          />
          <label className="form-check-label" htmlFor="edit-exp-current">
            Currently employed
          </label>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-exp-to"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            To
          </label>
          <div className="col-sm-10 col-md-5">
            <input
              type="date"
              className="form-control form-control-sm"
              id="edit-exp-to"
              name="to"
              value={to}
              onChange={(e) => onChange(e)}
              disabled={toDateDisabled ? 'disabled' : ''}
            />
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-exp-description"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            Job Description
          </label>
          <div className="col-sm-10 col-md-5">
            <textarea
              className="form-control form-control-sm"
              id="edit-exp-description"
              rows="2"
              name="description"
              value={description}
              onChange={(e) => onChange(e)}
            ></textarea>
          </div>
        </div>
        <div className="col-sm-10">
          <button type="submit" className="btn btn-primary btn-sm mx-3">
            Save
          </button>
          <Link to="/dashboard" className="btn btn-light btn-sm">
            Cancel
          </Link>
        </div>
      </form>
    </Fragment>
  );
};

AddExperience.propTypes = {
  addExperience: PropTypes.func.isRequired
};

export default connect(null, { addExperience })(withRouter(AddExperience));
